import React from "react";
import { FaMapMarkerAlt, FaCalendarAlt, FaRoute } from "react-icons/fa";
import "./upcomingTripsWidget.scss";
import { useGetItinerariesQuery } from "../features/api/itineraryApiSlice";

export default function UpcomingTripsWidget() {
  const { data: trips = [], isLoading, isError } = useGetItinerariesQuery();

  // 🟢 FIXED: Automatically filters out completed trips to keep the widget focused on the future
  const publicActiveTrips = trips.filter(
    (trip) =>
      trip.isPubliclyVisible &&
      (trip.status === "Planned" || trip.status === "In Progress")
  );

  if (isLoading) {
    return (
      <div className="upcoming-trips-widget upcoming-trips-widget--loading">
        <div className="widget-spinner">Mapping future routes...</div>
      </div>
    );
  }

  if (isError || publicActiveTrips.length === 0) return null;

  return (
    <aside className="upcoming-trips-widget fuel-fade-in">
      <div className="widget-header">
        <span className="widget-kicker">On The Horizon</span>
        <h2>Upcoming Expeditions</h2>
        <p>
          Follow along down the road. Here is where the small car is tracking
          next.
        </p>
      </div>

      <div className="widget-timeline-stack">
        {publicActiveTrips.map((trip) => (
          <div
            key={trip._id}
            className={`widget-trip-node widget-trip-node--${trip.status
              .toLowerCase()
              .replace(/\s+/g, "")}`}
          >
            <div className="node-status-indicator">
              <span className="status-pulse-dot" />
            </div>

            <div className="node-content-block">
              <div className="node-meta-top">
                <span className="node-status-label">
                  {trip.status === "In Progress"
                    ? "⚡ Active Now"
                    : "📁 Plotted"}
                </span>
                {trip.estimatedDate && (
                  <span className="node-date">
                    <FaCalendarAlt /> {trip.estimatedDate}
                  </span>
                )}
              </div>

              <h3>{trip.tripTitle}</h3>

              {trip.targetStates?.length > 0 && (
                <div className="node-geography">
                  <FaMapMarkerAlt /> <span>{trip.targetStates.join(", ")}</span>
                </div>
              )}

              {trip.routeStops?.length > 0 && (
                <div className="node-waypoints-preview">
                  <FaRoute />
                  <span className="waypoints-string">
                    {trip.routeStops.map((stop) => stop.stopName).join(" → ")}
                  </span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}
